$(document).on("change", ".js-inquiry-agree", function () {
  if ($(this).is(":checked")) {
    $(".js-inquiry-submit").removeClass("is-disabled");
  } else {
    $(".js-inquiry-submit").addClass("is-disabled");
  }
});
